// extracted by mini-css-extract-plugin
module.exports = {"title":"relatedContact_title__hoh2h","wrapper":"relatedContact_wrapper__VAFZ2","relatedContactWrapper":"relatedContact_relatedContactWrapper__Ud61A"};